export class FieldText {

	constructor(data) {
		this.data = data;
	}

	template = `
		<div class="">
            <label class="form-label"></label>
			<input type="text" name="prechat-form-text-input" class="form-control form-control-sm" />
			<div class="invalid-feedback"></div>
		</div>
	`;

	render() {
	    const element = jQuery(this.template);

        element.find('input').attr('name', this.data.slug)
        	.attr('required', this.data.mandatory);

        element.find('label').text(this.data.name);

        return element;
	}
}

